export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11275.aacd5ba7.jpg";